<!-- TEMPLATE FOR MODAL DIALOG -->
<div class="modal-header bg-white">
  <div class="container-fluid modal-title">
      <div class="col-lg-11 col-md-11 col-sm-11">
          <br />
      </div>
      <div class="col-lg-1 col-md-1 col-sm-1">
          <a class="link-hover font-weight-light" (click)="close()"><i class="fa-regular fa-xmark mr-2" title="Stäng"></i> Stäng</a>
      </div>
  </div>
</div>

<div class="modal-body">
  <div class="container-fluid">
      <div class="row">
          <div [innerHTML]="safeHtml"></div>
      </div>
  </div>
</div>

<div class="modal-footer">
  @if(!salesCompetitionData && salesCompetitionData.IsActive) {
      <div style="display:inline-block; margin-right:10px;">
          <button (click)="openSalesCompetition()" class="btn btn-primary btn-sm salesCompetitionButton" target="_blank" [attr.title]="salesCompetitionData.AlternativeText">{{salesCompetitionData.ButtonText}}</button>
      </div>
  }
  <div style="display:inline-block;"><button class="btn btn-primary" (click)="close()">Stäng</button></div>
</div>

